import { Card, Col, Row, Typography } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { TaxConfigurationList } from "./tax-configuration/list";
import { PlatformConfigPanel } from "./platform-config";
import { TallyTcpFilesPanel } from "./tally-tcp-files";
const { Text } = Typography;

export const GlobalConfigurationsShow: React.FC<IResourceComponentsProps> = () => {

    return (
        <Row gutter={[16, 16]}>
            <Col span={24} key='tax-configuration-section'>
                <Card
                    title={<Text strong>Tax Configurations</Text>}
                    bodyStyle={{ padding: 5 }}
                >
                    <TaxConfigurationList />
                </Card>
            </Col>
            <Col span={12} key='platform-config-section'>
                <Card
                    title={<Text strong>Platform Config</Text>}
                    bodyStyle={{ padding: 16 }}
                >
                    <PlatformConfigPanel />
                </Card>
            </Col>
            <Col span={24} key='tally-tcp-files-section'>
                <Card
                    title={<Text strong>Tally TCP Files</Text>}
                    bodyStyle={{ padding: 16 }}
                >
                    <TallyTcpFilesPanel />
                </Card>
            </Col>
        </Row>
    );
}